import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ErrorType } from '@dossierhq/core';
import { Card, Dialog, NotificationContext, Text, TextArea } from '@dossierhq/design';
import { useCallback, useContext, useMemo } from 'react';
import { DossierContext } from '../../contexts/DossierContext.js';
import { getSchemaSpecificationUpdateFromEditorState, SchemaEditorActions, } from '../../reducers/SchemaEditorReducer/SchemaEditorReducer.js';
export function SaveSchemaDialog({ show, schemaEditorState, dispatchSchemaEditorState, onClose, }) {
    const { client } = useContext(DossierContext);
    const { showNotification } = useContext(NotificationContext);
    const schemaSpecUpdate = useMemo(() => (show ? getSchemaSpecificationUpdateFromEditorState(schemaEditorState) : null), [schemaEditorState, show]);
    const handleClose = useCallback(async (_event, returnValue) => {
        if (returnValue === 'save' && schemaSpecUpdate) {
            dispatchSchemaEditorState(new SchemaEditorActions.SetNextUpdateSchemaSpecificationIsDueToSave(true));
            const result = await client.updateSchemaSpecification(schemaSpecUpdate, {
                includeMigrations: true,
            });
            if (result.isOk()) {
                showNotification({ color: 'success', message: 'Updated schema.' });
            }
            else {
                showNotification({
                    color: 'error',
                    message: `Failed saving schema. ${result.error === ErrorType.BadRequest
                        ? result.message
                        : `${result.error}: ${result.message}`}`,
                });
                dispatchSchemaEditorState(new SchemaEditorActions.SetNextUpdateSchemaSpecificationIsDueToSave(false));
            }
        }
        onClose();
    }, [client, dispatchSchemaEditorState, onClose, schemaSpecUpdate, showNotification]);
    return (_jsx(Dialog, { show: show, form: true, modal: true, onClose: handleClose, children: show && schemaSpecUpdate ? (_jsx(SaveSchemaDialogContent, { schemaSpecUpdate: schemaSpecUpdate })) : null }));
}
function SaveSchemaDialogContent({ schemaSpecUpdate, }) {
    return (_jsxs(Card, { children: [_jsx(Card.Header, { children: _jsx(Card.HeaderTitle, { children: "Save schema" }) }), _jsxs(Card.Content, { children: [_jsx(Text, { textStyle: "body1", children: "Do you want to save the following changes?" }), _jsx(TextArea, { fixedSize: true, textStyle: "code2", readOnly: true, style: { minHeight: '300px' }, defaultValue: JSON.stringify(schemaSpecUpdate, null, 2) })] }), _jsxs(Card.Footer, { children: [_jsx(Card.FooterButton, { children: "Cancel" }), _jsx(Card.FooterButton, { value: "save", children: "Save" })] })] }));
}
//# sourceMappingURL=SaveSchemaDialog.js.map